
export default function ComplianceNote() {
  return (
    <section id="compliance" className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-[#F1ECFF] rounded-xl p-8 border border-[#6B4EFF]/10">
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-shield-check-line text-[#6B4EFF] text-2xl" />
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Compliance & transparency</h3>
              <p className="text-gray-700 leading-relaxed">
                We do not collect PHI. Facilities do not receive sponsorship revenue. Sponsorships are clearly labeled. We may reject categories or claims that are not compliant with healthcare advertising standards.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
